import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import Input from "../../../UI/Input";
import Button from "../../../UI/Button";
import EmailChangeModal from "../../Modals/emailChangeModal";
import VerifyEmailModal from "../../Modals/verifyEmailModal";
import useInputHandler from "../../../Global/Hooks/inputHandler";
import useImageUploader from "../../../Global/Hooks/imageUploader";
import useEmailValidation from "../../../Global/Hooks/emailValidation";
import useUpdateProfile from "../../../Global/Api/Settings/updateProfileInfoApi";
import useDeleteProfileImageApi from "../../../Global/Api/Settings/deleteProfileImageApi";
import 'react-phone-number-input/style.css';
import "./index.scss";

export default function PersonalInfo() {
  const normalizePhoneToE164 = (phone) => {
    if (!phone) {
      return undefined;
    }

    const rawPhone = String(phone).trim();
    if (!rawPhone) {
      return undefined;
    }

    // react-phone-number-input expects E.164 values (e.g. +12125551212).
    if (!rawPhone.startsWith("+")) {
      return undefined;
    }

    const digits = rawPhone.replace(/\D/g, "");
    return digits ? `+${digits}` : undefined;
  };

  const accountIndex = useSelector((state) => state.rootReducer.techsbookSlice.userData);

  const updateProfileApi = useUpdateProfile();
  const deleteImageApi = useDeleteProfileImageApi();
  const [emailModal, setEmailModal] = useState(false);
  const [codeModal, setCodeModal] = useState(false);

  const firstName = useInputHandler("");
  const lastName = useInputHandler("");
  const companyName = useInputHandler("");
  const verificationKey = useInputHandler("");
  const emailValidation = useEmailValidation();
  const imageUploader = useImageUploader();
  const [phoneValue, setPhoneValue] = useState(normalizePhoneToE164(accountIndex?.phone));

  const isSubmitDisabled = !(
      firstName?.value?.length > 2 &&
      lastName?.value?.length > 2 &&
      companyName?.value?.length > 2 &&
      (phoneValue && isValidPhoneNumber(phoneValue))
  );

  const setProfileData = () => {
    firstName.setChange(accountIndex?.firstname || "");
    lastName.setChange(accountIndex?.lastname || "");
    companyName.setChange(accountIndex?.company_name || "");
    emailValidation.setChange(accountIndex?.email || "");
    setPhoneValue(normalizePhoneToE164(accountIndex?.phone));
    verificationKey.setChange(accountIndex?.verification_key || "");
  };

  useEffect(() => {
    setProfileData();
  }, [accountIndex]);

  const handleSubmit = (event) => {
    event.preventDefault();
    updateProfileApi.send({
      first_name: firstName?.value,
      last_name: lastName?.value,
      company_name: companyName.value,
      phone: phoneValue,
      verification_key: verificationKey
    });
  };

  const deleteImage = (event) => {
    deleteImageApi.send(imageUploader);
  };

  const openEmailModal = () => {
    setEmailModal(true);
  };

  return (
      <div className="personal">
        {emailModal && (
            <EmailChangeModal
                setEmailModal={setEmailModal}
                setCodeModal={setCodeModal}
            />
        )}
        {codeModal && <VerifyEmailModal setCodeModal={setCodeModal} />}
        <div className="personal-header">
          <p className="personal__title">Company Info</p>
          {accountIndex?.is_from_provider ? (
              <span className="personal-header-right">
            API customer
          </span>
          ) : (
              ""
          )}
        </div>

        <div className="personal__avatar">
          <input
              id="change"
              type="file"
              accept="image/*"
              onChange={imageUploader?.handleFileChange}
          />
          <span key={accountIndex}>
            <img
                key={accountIndex}
                src={
                  imageUploader?.previewImage
                      ? imageUploader?.previewImage
                      : accountIndex?.image
                          ? accountIndex?.image
                          : "/assets/icons/user-example.svg"
                }
                alt="avatar"
            />
          </span>
          <div className="personal__avatar__right">
            <div className="personal__avatar__right_rec">The recommended size is 240x240 pixels or a 1:1 aspect ratio</div>
            <div className="personal__avatar__right_r">
              <label htmlFor="change" className="personal__avatar-btn">
                Upload Company Logo
              </label>
              <div onClick={deleteImage} className="personal__avatar-delete">
                Delete image
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="personal__form">
          <div className="personal__inputs">
            <div className="personal__input">
              <Input
                  label="First name"
                  placeholder="Enter first name"
                  type="text"
                  id="first_name"
                  {...firstName}
              />
            </div>
            <div className="personal__input">
              <Input
                  label="Last name"
                  placeholder="Enter last name"
                  type="text"
                  id="last_name"
                  {...lastName}
              />
            </div>
          </div>
          <div className="personal__input" style={{ marginBottom: 20 }}>
            <Input
                label="Company name"
                placeholder="Company name"
                type="text"
                id="company_name"
                {...companyName}
            />
          </div>
          {
            verificationKey?.value?.length > 0 &&
              <div className="personal__input" style={{ marginBottom: 20 }}>
                <Input
                    label="Verification key"
                    placeholder="Verification key"
                    readOnly={true}
                    type="text"
                    id="verification_key"
                    {...verificationKey}
                />
              </div>
          }
          <div className="personal__input" style={{ marginBottom: 20 }}>
            <Input
                label="Email"
                placeholder="Enter email"
                type="email"
                id="email"
                change={true}
                disabled={true}
                changeInfo={openEmailModal}
                value={emailValidation?.value}
            />
          </div>

          <div className="personal__input">
            <label className='phone-label'>Phone</label>
            <PhoneInput
                // country="US"
                placeholder="Enter phone number"
                value={phoneValue}
                onChange={setPhoneValue}
                className="personal__input__phone"
            />
          </div>
          <div className="personal__btn">
            <Button text="Save changes" disabled={isSubmitDisabled} />
          </div>
        </form>
      </div>
  );
}